<template>
    <vue-modal :open="open">
        <div class="bax-modal-content bax-modal-icon-content text-center">
            <div class="bax-icon bax-remove d-flex align-items-center justify-content-center">
                <i class="icon-upload"></i>
            </div>
            <h2>Save for later</h2>
            <p>A draft of this registration for {{formData.patient_first_name}} {{formData.patient_last_name}} will be saved for 7 days, so you (or your colleagues) can return and complete it later. Would you like to save this as a draft registration?</p>
            <div class="bax-modal-action-items">
                <button type="button" class="bax-btn bax-btn-bordered-blue-brand" @click.prevent="closeModal">No, go back</button>
                <button type="button" class="bax-btn bax-btn-blue-brand" :class="{ 'loading': formSubmitting }" @click.prevent="onSave()">Yes, save for later</button>
            </div>
            <div class="feedback" v-if="error">
                {{error}}
            </div>
        </div>
    </vue-modal>
</template>
<script>

import PatientRegistationService from '@/core/api/tpn/patientRegistation.service';

export default {
    name: 'SaveRegistationModal',
    props: {
        open: {
            required: true,
        },
        formData: {
            required: true,
        },
        patientFormId: {
            required: true,
        },
    },
    data() {
        return {
            formSubmitting: false,
            error: false,
        };
    },
    methods: {
        closeModal() {
            if (!this.formSubmitting) {
                this.$emit('modal_save_close');
            }
        },
        onSave() {
            if (!this.formSubmitting) {
                this.formSubmitting = true;
                this.error = false;
                const payload = {
                    formData: this.formData,
                    patientFormId: this.patientFormId,
                };
                PatientRegistationService.savePatientRegistation(payload)
                .then((res) => {
                    if (res.data.error) {
                        this.error = 'Sorry, something went wrong';
                        this.formSubmitting = false;
                    } else {
                        // all good, redirect
                       this.$router.push({ name: 'homeTPN', query: { registrationSave: this.formData.patient_type, name: this.formData.patient_first_name + ' ' + this.formData.patient_last_name } });
                    }
                });
            }
        },
    },
};
</script>
